// @flow
import * as React from "react"

export default (props: any) => (
  <React.Fragment>
    <h1>AdminForm</h1>
    <pre>{JSON.stringify(props, null, " ")}</pre>
  </React.Fragment>
)
